import React, { useEffect, useState } from "react";
import { Grid, Typography, Box } from "@mui/material";
import NewTable from "Component/NewTable";
import { TrainingRequests } from "requests/TrainingRequests";
import { Label } from "recharts";
import Layout from "Component/Layouts/layout";

export default function Batch() {
  const [regionalUsers, setRegionalUsers] = useState([]);

  // useEffect(() => {
  //   const fetchRegionalUsers = async () => {
  //     let data = await TrainingRequests.getUsersbasedOnRegion("region1");
  //     console.log("data", data);
  //     setRegionalUsers([...regionalUsers, ...data]);
  //   };
  //   fetchRegionalUsers();
  // }, []);
  return (
    <Layout>
      <Box sx={{ padding: "20px" }}>
        <Grid container spacing={2}>
          {/* Title Section */}
          <Grid item xs={12}>
            <Typography
              variant="h4"
              sx={{
                fontWeight: "bold",
                textAlign: "center",
                marginBottom: "20px",
              }}
            >
              Select Employees
            </Typography>
          </Grid>

          {/* Table Section */}
          <Grid item xs={12}>
            <Box
              sx={{
                boxShadow: "0 4px 8px rgba(0, 0, 0, 0.2)",
                borderRadius: "8px",
                padding: "16px",
                backgroundColor: "#fff",
              }}
            >
              <NewTable
                // tableData={regionalUsers}
                fetchData={(params) =>
                  TrainingRequests.getUsersbasedOnRegion(params)
                }
                apiParams={{
                  region: "region1",
                }}
                columns={[
                  { label: "EmpID", id: "id" },
                  { label: "Name", id: "firstName" },
                  { label: "Username", id: "username" },
                  { label: "Email", id: "email" },
                ]}
                //rowsPerPageOptions={[5, 10, 25]}
                enableCheckbox={true}
              />
            </Box>
          </Grid>
        </Grid>
      </Box>
    </Layout>
  );
}
